import { render, staticRenderFns } from "./TheoryRatingView.vue?vue&type=template&id=60bc9705"
import script from "./TheoryRatingView.vue?vue&type=script&lang=js"
export * from "./TheoryRatingView.vue?vue&type=script&lang=js"
import style0 from "./TheoryRatingView.vue?vue&type=style&index=0&id=60bc9705&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports